import type { StateCreator } from 'zustand';
import deviceSlice, { type DeviceSlice } from './deviceSlice';
import devicesListSlice, { type DevicesListSlice } from './devicesListSlice';
import geofenceSlice, { type GeofenceSliceState } from './geofencesSlice';
import vehiclesSlice, { type VehiclesSlice } from './vehiclesSlice';

type MonitoringSlices = GeofenceSliceState & DevicesListSlice & DeviceSlice & VehiclesSlice;

const monitoringSlices: StateCreator<MonitoringSlices, [['zustand/devtools', never]]> = (setState, getState, store) => ({
  ...geofenceSlice(setState, getState, store),
  ...devicesListSlice(setState, getState, store),
  ...deviceSlice(setState, getState, store),
  ...vehiclesSlice(setState, getState, store),
});

export type { MonitoringSlices };
export default monitoringSlices;
